export var LiquidatorName;
(function (LiquidatorName) {
    LiquidatorName["KRAKEN"] = "kraken";
    LiquidatorName["BYBIT"] = "bybit";
    LiquidatorName["BTSE"] = "btse";
    LiquidatorName["WHITEBIT"] = "whitebit";
    LiquidatorName["BITGET"] = "bitget";
})(LiquidatorName || (LiquidatorName = {}));
//# sourceMappingURL=liquidator-name.enum.js.map